import authRules from '../authRules';

const approvals = (user) => {
  const { approvals } = user.securityLevels;

  if (approvals >= authRules.approvals.approvals) {
      return true;
  } else {
      return false;
    }
  }


export default approvals;



// WEBPACK FOOTER //
// ./src/AuthLogic/rules/approvals.js